import { Type } from 'class-transformer';
import {
	ArrayMaxSize,
	IsArray,
	IsIn,
	IsInt,
	IsNumber,
	IsOptional,
	IsString,
	Min,
	ValidateNested,
} from 'class-validator';
import { IsBoolean, ParseJson } from '../../decorators';

const SORT_DIRECTION = ['ASC', 'DESC'] as const;

class DateRangeFilter {
	@IsString()
	@IsOptional()
	public startDate?: string | null;

	@IsString()
	@IsOptional()
	public endDate?: string | null;
}

class ItemFilters {
	@IsString()
	@IsOptional()
	public search?: string;

	@IsString()
	@IsOptional()
	public itemSearch?: string;

	@IsArray()
	@IsString({ each: true })
	@IsOptional()
	public itemCategories?: Array<string>;

	@IsArray()
	@IsString({ each: true })
	@IsOptional()
	public itemManufacturers?: Array<string>;

	@IsArray()
	@IsInt({ each: true })
	@IsOptional()
	public itemCompany?: Array<number>;

	@IsArray()
	@IsInt({ each: true })
	@IsOptional()
	public itemWarehouse?: Array<number>;

	@Type(() => Number)
	@IsInt()
	@IsOptional()
	public warehouseId?: number;

	@Type(() => Number)
	@IsInt()
	@IsOptional()
	public locationId?: number;

	@IsString()
	@IsOptional()
	public itemStatus?: string;

	@IsString()
	@IsOptional()
	public itemShortDate?: string;

	@IsString()
	@IsOptional()
	public stock_status?: string;

	@IsArray()
	@IsInt({ each: true })
	@IsOptional()
	public itemGroups?: Array<number>;

	@IsArray()
	@IsInt({ each: true })
	@IsOptional()
	public excludeItemGroups?: Array<number>;

	@ValidateNested()
	@Type(() => DateRangeFilter)
	@IsOptional()
	public itemRestockedDateRange?: DateRangeFilter;

	@ValidateNested()
	@Type(() => DateRangeFilter)
	@IsOptional()
	public itemCreatedDateRange?: DateRangeFilter;
}

class SortFields {
	@IsString()
	public objectTable!: string;

	@IsString()
	public fieldName!: string;

	@IsIn(SORT_DIRECTION)
	public direction!: (typeof SORT_DIRECTION)[number];
}

export class GetItemsRequestDto {
	@Type(() => Number)
	@IsNumber()
	@Min(1)
	@IsOptional()
	public limit: number = 25;

	@Type(() => Number)
	@IsNumber()
	@Min(1)
	@IsOptional()
	public page: number = 1;

	@IsString()
	@IsOptional()
	public search?: string;

	@IsArray()
	@ArrayMaxSize(1000)
	@IsInt({ each: true })
	@Type(() => Number)
	@IsOptional()
	public excludeItemIds?: Array<number>;

	@IsOptional()
	@ValidateNested()
	@ParseJson({ type: ItemFilters })
	public filters?: ItemFilters;

	@IsOptional()
	@IsArray()
	@ValidateNested({ each: true })
	@ParseJson({ type: SortFields })
	public sortFields?: Array<SortFields>;

	@IsBoolean()
	@IsOptional()
	public includeUnmatched: boolean = false;

	@IsBoolean()
	@IsOptional()
	public includeImages: boolean = false;

	@IsBoolean()
	@IsOptional()
	public countOnly: boolean = false;

	@IsOptional()
	@IsString()
	public cacheKey?: string;

	@Type(() => Number)
	@IsNumber()
	@IsOptional()
	public cacheTTL?: number;

	@IsOptional()
	@IsString()
	public listId?: string;

	@IsOptional()
	@IsArray()
	@IsString({ each: true })
	public fields?: Array<string>;
}
